import { render, staticRenderFns } from "./UserCouponList.vue?vue&type=template&id=b541b4ae"
import script from "./UserCouponList.vue?vue&type=script&lang=ts"
export * from "./UserCouponList.vue?vue&type=script&lang=ts"
import style0 from "./UserCouponList.vue?vue&type=style&index=0&id=b541b4ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports